import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ContainerDimensions from 'react-container-dimensions';
import { getImageByWidth } from '../../utils/api';
import ExternalMediaPlayer from '../ExternalMediaPlayer';


const TimelineSlide = ({
  dateDisplay,
  dateFormatted,
  headline,
  description,
  quoteAttribution,
  layout,
  mediaSource,
  mediaUrl,
  media,
  mediaDescription,
  mediaCredit,
  shouldPreload,
  isCurrent,
}) => {
  let mediaColumn = null;
  let renderedMedia = null;

  // TODO: support other media types from library
  if (mediaSource === 'url' && mediaUrl) {
    renderedMedia = <ExternalMediaPlayer mediaUrl={mediaUrl} load={isCurrent} />;
  } else if (mediaSource === 'media_library' && media && media.type === 'image') {
    const imageVersion = getImageByWidth(media.versions, 900);
    const imageUrl = imageVersion ? imageVersion.url : null;
    renderedMedia = shouldPreload ? (
      <ContainerDimensions>
        {({ width, height }) => {
          const styles = { maxHeight: width, marginLeft: 'auto', marginRight: 'auto' };
          return imageUrl ? <img src={imageUrl} alt={mediaDescription} style={styles} /> : null;
        }}
      </ContainerDimensions>
    ) : (
      <div className="ar-3-2 loading-spinner" />
    );
  }

  if (renderedMedia) {
    mediaColumn = (
      <div className="col-md-6 mb-3 slide-media-col">
        <div className="mb-2 slide-media-viewer">
          {renderedMedia}
        </div>
        <div className="slide-media-info mb-4">
          {mediaCredit ? <div className="meta text-right mb-1"><div dangerouslySetInnerHTML={{ __html: mediaCredit }} /></div> : null }
          {mediaDescription ? <div className="caption mediaDescription"><div dangerouslySetInnerHTML={{ __html: mediaDescription }} /></div> : null }
        </div>
      </div>
    );
  }

  const hasMedia = !!mediaColumn;
  const isQuoteLayout = layout === 'quote';
  const textColumnClasses = classNames({
    'col-md-6': !isQuoteLayout,
    'col-12': !hasMedia && isQuoteLayout,
    'align-items-center': !hasMedia,
    'd-flex': !hasMedia,
    // 'pt-md-5': true,
  });
  const textColumn = (
    <div className={textColumnClasses}>
      <div className="w-100" style={{ maxHeight: '100%' }}>
        <h5 className="slide-date">{dateDisplay || dateFormatted}</h5>
        <h2 className="heading-display mb-3" dangerouslySetInnerHTML={{ __html: headline }} />
        {description && isQuoteLayout
          ? (
            <div className="slide-quote">
              <blockquote className="mb-2" dangerouslySetInnerHTML={{ __html: description }} />
              <cite>– {quoteAttribution}</cite>
            </div>
          ) : null
        }
        {description && !isQuoteLayout ? <div className="pb-4"><div className="body-copy" dangerouslySetInnerHTML={{ __html: description }} /></div> : null}
      </div>
    </div>
  );

  return (
    <div className="timeline-slides-item">
      <div className="row justify-content-center">
        {mediaColumn}
        {textColumn}
      </div>
    </div>
  );
};

TimelineSlide.propTypes = {
  dateDisplay: PropTypes.string,
  dateFormatted: PropTypes.string,
  headline: PropTypes.string,
  description: PropTypes.string,
  media: PropTypes.object,
  shouldPreload: PropTypes.bool,
  isCurrent: PropTypes.bool,
};

export default TimelineSlide;



// WEBPACK FOOTER //
// ./src/components/Timeline/TimelineSlide.js